import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Colors, Sizes, Variants } from 'shared/components/ui/button';

import * as Styled from './form.style';

export type FooterProps = {
  onCancel: () => void;
  onSubmit: () => void;
  isValid: boolean;
};

export const Footer: React.FC<FooterProps> = ({
  onCancel,
  onSubmit,
  isValid,
}) => {
  const { t } = useTranslation();

  return (
    <Styled.FooterContainer>
      <Button
        variant={Variants.Outlined}
        size={Sizes.Small}
        color={Colors.Inherit}
        onClick={onCancel}
        type="button"
        fullWidth
        alignCenter
      >
        {t('general.labels.cancel')}
      </Button>
      <Button
        variant={Variants.Contained}
        size={Sizes.Small}
        onClick={onSubmit}
        disabled={!isValid}
        fullWidth
        alignCenter
      >
        {t('general.labels.save')}
      </Button>
    </Styled.FooterContainer>
  );
};
